import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { useNotifications } from '../NotificationSystem';
import { auditPhotoService } from '../../services/auditPhotoService';
import './PhotoUploader.css';

const PhotoUploader = ({ auditId, userId, photos = [], onChange, disabled }) => {
  const { t } = useTranslation(['qms']);
  const { notify } = useNotifications();
  const [busy, setBusy] = useState(false);

  const handleFiles = async (e) => {
    const files = e.target.files;
    if (!files?.length || !auditId) return;
    e.target.value = '';

    for (let i = 0; i < files.length; i += 1) {
      const file = files[i];
      const size = file.size;
      if (!auditPhotoService.validateTotalSize(photos, size)) {
        if (photos.length >= 20) {
          notify.error(t('qms:photoMaxCountExceeded'));
        } else {
          notify.error(t('qms:photoSizeExceeded'));
        }
        continue;
      }
      setBusy(true);
      try {
        const meta = await auditPhotoService.uploadPhoto(auditId, file, userId);
        onChange?.([...photos, meta]);
      } catch (err) {
        console.error('[PhotoUploader]', err);
        notify.error(err.message || t('qms:uploadFailed'));
      } finally {
        setBusy(false);
      }
    }
  };

  const removeAt = async (index) => {
    const p = photos[index];
    const next = photos.filter((_, j) => j !== index);
    try {
      if (p?.storagePath) {
        await auditPhotoService.deletePhoto(p.storagePath);
      }
    } catch (err) {
      console.warn('[PhotoUploader] delete storage', err);
    }
    onChange?.(next);
  };

  return (
    <div className="photo-uploader">
      {!disabled && (
        <div className="photo-uploader-actions">
          <label className="btn btn-secondary btn-sm photo-uploader-label">
            {busy ? t('qms:uploadingPhoto') : t('qms:addPhotos')}
            <input
              type="file"
              accept="image/jpeg,image/png"
              multiple
              className="photo-uploader-file"
              onChange={handleFiles}
              disabled={busy}
            />
          </label>
        </div>
      )}
      {!photos.length ? (
        <p className="photo-uploader-empty">{t('qms:noPhotosYet')}</p>
      ) : (
        <div className="photo-uploader-grid">
          {photos.map((p, idx) => (
            <div key={p.storagePath || idx} className="photo-uploader-thumb-wrap">
              <img src={p.url} alt="" className="photo-uploader-thumb" />
              {!disabled && (
                <button
                  type="button"
                  className="photo-uploader-remove"
                  onClick={() => removeAt(idx)}
                  aria-label={t('qms:deletePhoto')}
                >
                  <X size={14} />
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PhotoUploader;
